"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RecoverableUpdateStreamImpl = exports.PendingTopicUpdate = void 0;
var error_reason_1 = require("./../../errors/error-reason");
var errors_1 = require("./../../errors/errors");
var logger = require("./../util/logger");
var math_1 = require("./../util/math");
var require_non_null_1 = require("./../util/require-non-null");
var log = logger.create('diffusion.RecoverableUpdateStream');
/**
 * A record of a topic update that is pending application to a
 * topic.
 */
var PendingTopicUpdate = /** @class */ (function () {
    function PendingTopicUpdate(counter, updateValue) {
        this.counter = counter;
        this.updateValue = updateValue;
    }
    PendingTopicUpdate.prototype.initPromise = function (newPromise) {
        this.promise = newPromise;
    };
    PendingTopicUpdate.prototype.getPromise = function () {
        return this.promise;
    };
    return PendingTopicUpdate;
}());
exports.PendingTopicUpdate = PendingTopicUpdate;
/**
 * {@link RecoverableUpdateStream} feature implementation.
 *
 * @since 6.10
 */
var RecoverableUpdateStreamImpl = /** @class */ (function () {
    /**
     * Constructor.
     */
    function RecoverableUpdateStreamImpl(supplier, strategy) {
        this.counter = math_1.MIN_SAFE_INTEGER;
        this.priorException = undefined;
        this.queue = [];
        this.streamSupplier = require_non_null_1.requireNonNull(supplier, 'supplier');
        this.delegate = require_non_null_1.requireNonNull(supplier(), 'supplier return value');
        this.strategy = require_non_null_1.requireNonNull(strategy, 'strategy');
    }
    RecoverableUpdateStreamImpl.prototype.set = function (value) {
        return __awaiter(this, void 0, void 0, function () {
            var update, promise, topicCreationResult, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.recoveryCompletionPromise !== undefined)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.recoveryCompletionPromise];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 4, , 5]);
                        update = new PendingTopicUpdate(this.counter++, value);
                        this.queue.push(update);
                        promise = this.delegate.set(value);
                        update.initPromise(promise);
                        return [4 /*yield*/, promise];
                    case 3:
                        topicCreationResult = _a.sent();
                        this.processUpdateResponse(update, topicCreationResult);
                        return [2 /*return*/, topicCreationResult];
                    case 4:
                        err_1 = _a.sent();
                        this.processException(err_1);
                        throw err_1;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    RecoverableUpdateStreamImpl.prototype.get = function () {
        return this.delegate.get();
    };
    RecoverableUpdateStreamImpl.prototype.validate = function () {
        return __awaiter(this, void 0, void 0, function () {
            var err_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.recoveryCompletionPromise !== undefined)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.recoveryCompletionPromise];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 4, , 5]);
                        return [4 /*yield*/, this.delegate.validate()];
                    case 3: return [2 /*return*/, _a.sent()];
                    case 4:
                        err_2 = _a.sent();
                        this.processException(err_2);
                        throw err_2;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    RecoverableUpdateStreamImpl.prototype.isRecoverable = function () {
        return this.isRecoverableImpl();
    };
    RecoverableUpdateStreamImpl.prototype.recover = function () {
        return __awaiter(this, void 0, void 0, function () {
            var recoveryComplete, reattempts, needsRecovery, err_3;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.isRecoverableImpl(this.priorException)) {
                            throw new errors_1.IllegalStateError('Can only recover following a recoverable exception');
                        }
                        this.priorException = undefined;
                        recoveryComplete = undefined;
                        this.recoveryCompletionPromise = new Promise(function (resolve) {
                            recoveryComplete = resolve;
                        });
                        this.synchronisePendingWork();
                        reattempts = this.strategy.attempts;
                        needsRecovery = true;
                        _a.label = 1;
                    case 1:
                        if (!(this.queue.length !== 0 || needsRecovery)) return [3 /*break*/, 8];
                        needsRecovery = false;
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 6, , 7]);
                        // eslint-disable-next-line no-await-in-loop
                        return [4 /*yield*/, new Promise(function (resolve) { return setTimeout(resolve, _this.strategy.interval); })];
                    case 3:
                        // eslint-disable-next-line no-await-in-loop
                        _a.sent();
                        log.trace("Attempting recovery of " + this.queue.length + " topic updates");
                        this.delegate = this.streamSupplier();
                        // eslint-disable-next-line no-await-in-loop
                        return [4 /*yield*/, this.delegate.validate()];
                    case 4:
                        // eslint-disable-next-line no-await-in-loop
                        _a.sent();
                        // eslint-disable-next-line no-await-in-loop
                        return [4 /*yield*/, Promise.all(this.queue.map(function (update) {
                                return _this.delegate
                                    .set(update.updateValue)
                                    .then(function (topicCreationResult) {
                                    return _this.processUpdateResponse(update, topicCreationResult);
                                });
                            }))];
                    case 5:
                        // eslint-disable-next-line no-await-in-loop
                        _a.sent();
                        log.trace("Completed recovery during attempt " + (this.strategy.attempts - reattempts));
                        recoveryComplete();
                        this.recoveryCompletionPromise = undefined;
                        return [3 /*break*/, 7];
                    case 6:
                        err_3 = _a.sent();
                        this.processUpdateError(err_3);
                        needsRecovery = true;
                        if (reattempts !== math_1.MAX_SAFE_INTEGER) {
                            reattempts--;
                        }
                        if (!this.isRecoverableImpl(err_3) || reattempts <= 0) {
                            recoveryComplete();
                            this.recoveryCompletionPromise = undefined;
                            throw new errors_1.RetryLimitError('Cannot recover within strategy: ' + JSON.stringify(this.strategy));
                        }
                        return [3 /*break*/, 7];
                    case 7: return [3 /*break*/, 1];
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    RecoverableUpdateStreamImpl.prototype.synchronisePendingWork = function () {
        return __awaiter(this, void 0, void 0, function () {
            var err_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, Promise.all(this.queue.map(function (update) { return update.getPromise(); }))];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        err_4 = _a.sent();
                        log.debug('Synchronizing pending work', err_4);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    RecoverableUpdateStreamImpl.prototype.processUpdateResponse = function (update, topicCreationResult) {
        log.trace('Received set response: {}, result: {}', update.updateValue, topicCreationResult);
        var updateIndex = this.queue.findIndex(function (entry) { return entry.counter === update.counter; });
        /* istanbul ignore else */
        if (updateIndex !== -1) {
            this.queue.splice(updateIndex, 1);
        }
        else {
            throw new errors_1.AssertionError('Cannot find topic update in queue ' + update);
        }
    };
    RecoverableUpdateStreamImpl.prototype.processUpdateError = function (err) {
        this.processException(err);
        if (this.isRecoverableImpl(err)) {
            log.trace("Recoverable error detected. " + this.queue.length + " updates can be recovered.", err);
        }
    };
    RecoverableUpdateStreamImpl.prototype.processException = function (err) {
        if (this.priorException === undefined) {
            this.priorException = err;
        }
    };
    RecoverableUpdateStreamImpl.prototype.isRecoverableImpl = function (cause) {
        var exception = cause !== null && cause !== void 0 ? cause : this.priorException;
        if (exception === undefined || exception === null) {
            return false;
        }
        // eslint-disable-next-line deprecation/deprecation
        return exception.id === error_reason_1.ErrorReason.CLUSTER_ROUTING.id ||
            (exception.cause !== undefined && this.isRecoverableImpl(exception.cause));
    };
    return RecoverableUpdateStreamImpl;
}());
exports.RecoverableUpdateStreamImpl = RecoverableUpdateStreamImpl;
